import user from 'js/lib/user';

import { useNaptime } from 'bundles/naptimejs';
import SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';

export type PropsFromUseGetLoggedInUserSubscriptions = {
  subscriptions: Array<SubscriptionsV1>;
};

type InputProps = {
  skip?: boolean;
};

export const useGetLoggedInUserSubscriptions = ({ skip }: InputProps) => {
  const {
    data: { subscriptions },
    pending,
  } = useNaptime<PropsFromUseGetLoggedInUserSubscriptions>(() => {
    if (skip || !user.isAuthenticatedUser()) {
      return {};
    }

    return {
      subscriptions: SubscriptionsV1.me({
        fields: [
          'cartId',
          'id',
          'isActive',
          'nextBillingAt',
          'paymentProcessorId',
          'productItemId',
          'productType',
          'status',
          'productSku',
          'paymentInformation',
        ],
      }),
    };
  });

  return { subscriptions, pending };
};
